import React, { useState, useEffect, useRef } from "react";
import "../ProductsDetailsMensTshirt/MensTshirt1.css";
import tshirt1 from "../assets/tshirt-3.jpg";
import tshirt2 from "../assets/tshirt-3-b.jpg";
import tshirt3 from "../assets/tshirt-3-c.jpg";
import { Link } from "react-router-dom";

const MensTshirt3 = () => {
    const images = [tshirt1, tshirt2, tshirt3];
    const [current, setCurrent] = useState(0);
    const [backgroundPos, setBackgroundPos] = useState("50% 50%");
    const [isMagnify, setIsMagnify] = useState(false);
  
    const handleMouseMove = (e) => {
      const { left, top, width, height } = e.target.getBoundingClientRect();
      const x = ((e.pageX - left) / width) * 100;
      const y = ((e.pageY - top) / height) * 100;
      setBackgroundPos(`${x}% ${y}%`);
    };
  
    return (
      <div className="joggers-page">
        <h1 className="joggers-title">Men’s T-Shirt</h1>
        <div className="joggers-container">
          {/* Left side - Photo Grid */}
          <div className="joggers-gallery">
            <div
              className={`joggers-main ${isMagnify ? "magnify" : ""}`}
              style={{
                backgroundImage: isMagnify ? `url(${images[current]})` : "none",
                backgroundPosition: backgroundPos,
                backgroundSize: isMagnify ? "200%" : "cover",
              }}
              onMouseMove={handleMouseMove}
              onMouseEnter={() => setIsMagnify(true)}
              onMouseLeave={() => setIsMagnify(false)}
            >
              <img
                src={images[current]}
                alt="Jogger"
                className="joggers-main-img"
              />
            </div>
  
            <div className="joggers-thumbnails">
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Thumbnail ${index}`}
                  className={`joggers-thumb ${current === index ? "active" : ""}`}
                  onClick={() => setCurrent(index)}
                />
              ))}
            </div>
          </div>
  
          {/* Right side - Product Info */}
          <div className="joggers-info">
            <h2>Model No.MG-25725-10</h2>
            <button className="joggers-btn">
  <Link to="/contact" className="joggers-link">Contact Us</Link>
</button>
          </div>
        </div>
      </div>
    );
  };

export default MensTshirt3;
